import clsx from "clsx";

import { DxIcon } from "../../../../dx/ui/icons";
import type { BrowseRoomType } from "../../../_hooks/use-room-type-search";

/**
 * 建築タイプ見出しの人数行（アイコン付き）。arch から表示ラベルを導出する。
 * ArchitectureTypeGroup（展開時）と SingleSelectionArchitecture で共用。
 */
export function ArchSpecRow({
  arch,
  className,
}: {
  arch: BrowseRoomType["architectureType"];
  className?: string;
}) {
  const capacityLabel =
    arch?.content?.capacityDescription ||
    (arch?.capacity ? `${arch.capacity}名` : null);
  if (capacityLabel === null) return null;
  return (
    <div className={clsx("flex flex-col gap-[4px]", className)}>
      <span className="font-notojp text-dx-text-default flex items-center gap-[4px] text-[14px] leading-[24px]">
        <DxIcon
          src="/i/dx/person.svg"
          className="text-dx-text-default size-[16px]"
        />
        {capacityLabel}
      </span>
    </div>
  );
}
